module.exports = __webpack_public_path__ + "img/Z61_07.a98bcef7.jpg";